import { render, staticRenderFns } from "./datosInmuebles2.vue?vue&type=template&id=2e28c35f&scoped=true"
import script from "./datosInmuebles2.vue?vue&type=script&lang=js"
export * from "./datosInmuebles2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e28c35f",
  null
  
)

export default component.exports